var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 34,
    viewBox: "0 0 64 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6899 8.44996C13.7848 8.1734 13.9671 7.93522 14.2093 7.77137C14.4515 7.60753 14.7404 7.52691 15.0324 7.54168C15.3205 7.52228 15.6067 7.6017 15.8435 7.76683C16.0804 7.93196 16.254 8.17293 16.3354 8.44996L24.4298 29.8905H29.6023L20.5991 6.19946C19.6513 3.71195 17.8351 2.76416 15.0713 2.76416C12.2678 2.76416 10.4515 3.71195 9.46452 6.19946L0.106995 29.8905H5.24005L13.6899 8.44996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2504 0.000306063V20.9668C33.2504 26.9689 35.8959 29.8904 40.9104 29.8904H46.6752C52.203 29.8904 55.6784 26.4946 55.6784 19.4662C55.6784 12.4379 52.2036 9.0421 46.6752 9.0421H37.4356V0L33.2504 0.000306063ZM46.241 13.07C49.8735 13.07 51.4531 14.9652 51.4531 19.4665C51.4531 23.9678 49.8735 25.8236 46.241 25.8236H42.1344C38.7386 25.8236 37.4356 24.3231 37.4356 20.7708V13.07H46.241Z",
    fill: "#38B500"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_2826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 13,
    width: 6,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0931 16.6926C51.0931 16.6926 51.2122 14.3558 54.4081 13.2935C55.5442 14.4146 55.2438 14.6072 55.2438 14.6072L56.6831 19.2641L55.6906 20.1861L51.2481 20.5095L51.0931 16.6926Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_2826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2285 -0.0255728V20.9409C33.2285 26.943 35.874 29.8645 40.8886 29.8645H46.6534C52.1812 29.8645 55.6566 26.4687 55.6566 19.4404C55.6566 12.412 52.1818 9.01622 46.6534 9.01622H37.4138V-0.0258789L33.2285 -0.0255728ZM46.2191 13.0441C49.8517 13.0441 51.4312 14.9394 51.4312 19.4407C51.4312 23.942 49.8517 25.7977 46.2191 25.7977H42.1126C38.7168 25.7977 37.4138 24.2972 37.4138 20.7449V13.0441H46.2191Z",
    fill: "url(#paint0_linear_201_2826)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_201_2826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 7,
    width: 27,
    height: 25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4671 7.84098V14.5563H39.4942L38.9929 22.7814L48.9375 22.9991L49.722 21.4787L50.0046 20.5484H56.1905V29.5372L42.0463 31.8618L34.4211 30.1294L32.0307 24.5937C32.0307 24.5937 30.6643 16.308 30.7357 15.7813C30.807 15.2545 30.4943 8.60135 30.4943 8.60135L33.2424 7.4585L44.4671 7.84098Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_201_2826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6216 20.9093C55.6216 26.9115 53.0355 29.858 48.021 29.858H42.2561C36.7284 29.858 33.2529 26.4622 33.2529 19.4339C33.2529 12.4056 36.7277 9.00977 42.2561 9.00977H51.4958L55.6216 20.9093ZM42.6904 13.0373C39.0579 13.0373 37.4783 14.9326 37.4783 19.4339C37.4783 23.9352 39.0579 25.7906 42.6904 25.7906H46.7969C50.1927 25.7906 51.4958 24.2901 51.4958 20.7378V13.0373H42.6904Z",
    fill: "#38B500"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.405 13.1123H39.6019C38.2489 13.1123 37.1521 14.2091 37.1521 15.5622V24.3152C37.1521 25.6682 38.2489 26.765 39.6019 26.765H49.405C50.758 26.765 51.8549 25.6682 51.8549 24.3152V15.5622C51.8549 14.2091 50.758 13.1123 49.405 13.1123Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.786 20.6119C46.8684 17.3095 52.6721 9.46293 57.0773 7.10709C62.9009 4.30813 63.8931 10.6468 63.8931 10.6468C63.8931 10.6468 61.4873 8.9809 58.9851 10.3207C52.899 13.5738 45.1514 24.5237 45.1385 24.5513L42.6149 22.0276L39.1796 18.5084L41.634 16.2836L44.786 20.6119Z",
    fill: "#38B500"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2124 29.8394H40.7055V32.3416H48.2124V29.8394Z",
    fill: "url(#paint1_linear_201_2826)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0825 32.332H39.8374C39.3269 32.332 38.9129 33.0789 38.9129 34.0001H50.007C50.007 33.0789 49.593 32.332 49.0825 32.332Z",
    fill: "#38B500"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_2826",
    x1: 54.6025,
    y1: 17.6991,
    x2: 49.6193,
    y2: 13.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_2826",
    x1: 44.4589,
    y1: 29.8394,
    x2: 44.4589,
    y2: 32.3416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#298301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseTitleIcon);
export default __webpack_public_path__ + "static/media/collapse-title-icon.21bc8ceb5e620c4e6d772211b9e22e3b.svg";
export { ForwardRef as ReactComponent };